<template>
  <!-- 专区列表管理 -->
  <div class="homeBrand">
    <!-- 面包屑导航 -->
    <page-bar
      @back="goBack"
      @refresh="handleRefresh"
      :title="$route.meta.title"
    >
      <template slot="controls">
        <div>
          <span style="margin-right: 20px">设置是否在APP、PC首页楼层显示</span>
        </div>
      </template>
    </page-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">是否启用：</label>
        <el-select
          placeholder="是否启用"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option
            v-for="(item, index) in stausList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" @click="seach" icon="el-icon-search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="entName"
        show-overflow-tooltip
        label="机构名称"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="id"
        show-overflow-tooltip
        label="品牌编号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="品牌名称"
      >
      </el-table-column>
      <el-table-column
        prop="type"
        label="类别"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="创建日期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="state"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.state == 1">已下架</el-tag>
          <el-tag type="success" v-if="scope.row.state == 2">已上架</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="首页显示状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 44">已显示</el-tag>
          <el-tag type="warning" v-if="scope.row.status == 2">未显示</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="des"
        label="备注"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" width="140" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status == 2"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 44)"
            >显示</el-button
          >
          <el-button
            v-if="scope.row.status == 44"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            >隐藏</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "homeBrand",
  data() {
    return {
      /**表格数据 */
      // {
      //   entId: '机构ID',
      //   entName: '机构名称',
      //   id: '品牌编号',
      //   name: '品牌名称',
      //   type: '类别',
      //   sort: '排序',
      //   time: '创建日期',
      //   state: '状态',
      //   status: '首页显示状态',
      //   des: '备注',
      // }
      tableData: [],
      searchForm: {
        /**搜索表单 */ status: "9",
        name: "",
      },
      stausList: [
        {
          value: "9",
          label: "全部",
        },
        {
          value: "1",
          label: "未上架",
        },
        {
          value: "2",
          label: "已上架",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    seach() {
      this.getTableData(1);
    },
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "Query_Brand",
        status: this.searchForm.status,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Brand"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "brand/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          console.log(res);
          this.tableData = [];
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            this.tableData = res.data.map((item) => ({
              entId: item.entId,
              entName: item.entname,
              id: item.billno,
              name: item.name,
              type: item.faType,
              sort: item.sort_id,
              time: item.add_time,
              state: item.status,
              status: item.floor_id,
              des: item.beizhu,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    // 删除，上下架
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let msgType = "info";
      if (status == 44) {
        msg = "确定要展示在首页吗?";
        msgType = "success";
      } else if (status == 2) {
        msg = "确定不展示在首页吗?";
        msgType = "warning";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: msgType,
      })
        .then(() => {
          let data = {
            fabh: row.id,
            status: status,
          };
          this.$request({
            method: "post",
            url: "Brand/BrandRecommended",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.homeBrand {
  width: 100%;
  height: 100%;
}
</style>
